// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cookieConsentContainer {
  z-index: 50000;
  width: 350px;
  min-height: 20px;
  box-sizing: border-box;
  padding: 30px 30px 30px 30px;
  background: #232323;
  color: white;
  overflow: hidden;
  position: fixed;
  bottom: 30px;
  right: 30px;
  display: none;
  opacity: 0;
  transition: opacity 1s ease-out;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 45px, rgba(0, 0, 0, 0.22) 0px 10px 18px;
}
.cookieConsentContainer .cookieTitle a {
  font-family: OpenSans, arial, "sans-serif";
  color: #FFFFFF;
  font-size: 22px;
  line-height: 20px;
  display: block;
}
.cookieConsentContainer .cookieDesc p {
  margin: 0;
  padding: 4px;
  font-family: OpenSans, arial, "sans-serif";
  color: #FFFFFF;
  font-size: 13px;
  line-height: 20px;
  display: block;
  margin-top: 10px;
}
.cookieConsentContainer .cookieDesc a {
  font-family: OpenSans, arial, "sans-serif";
  color: #FFFFFF;
  text-decoration: underline;
}
.cookieConsentContainer .cookieButton {
  cursor: pointer;
}
.cookieConsentContainer .cookieButton a {
  display: inline-block;
  font-family: OpenSans, arial, "sans-serif";
  color: #FFFFFF;
  font-size: 14px;
  font-weight: bold;
  margin-top: 14px;
  background: #000000;
  box-sizing: border-box;
  padding: 15px 24px;
  text-align: center;
  transition: background 0.3s;
}
.cookieConsentContainer .cookieButton :hover {
  background: #3E9B67;
}
.cookieConsentContainer .rs-panel-heading {
  padding: 5px;
}
@media (max-width: 980px) {
  .cookieConsentContainer {
    bottom: 0px !important;
    left: 0px !important;
    width: 100% !important;
  }
}
.yodiwo-avatar {
  color: white;
  background-color: transparent;
  user-select: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  border-radius: 50%;
  height: 40px;
  width: 40px;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
